import moment from "moment";
import reportAction from "../actions/reportAction";
import helpersTime from "../../helpers/time";
import WhichTypeSelect from "../../component/sections/report/constants/WhichTypeSelect";
import eventAdvertise from "../actions/eventAdvertise";
import activeChart from "../actions/activeChart";
import separationDataActive from "../actions/separationDataActive";

const mainState = {
  all_site_publisher: [],

  site_publisher_ID: 0,

  count_all_site_publisher: 0,
  count_all_positions: 0,
  count_view_advertise_in_position_on_site_publisher: 0,
  time_second_view_advertise_in_position_on_site_publisher: 0,
  income: 0,

  which_type_select: WhichTypeSelect.ALL_SITE_PUBLISHER,
  separation_data_chart: separationDataActive.POSITION,

  date_from: helpersTime.addStartTime(helpersTime.getLastDayDate(1)),
  date_to: helpersTime.addStartTime(moment().format("YYYY-MM-DD")),

  data_chart: [],
  data_chart_separation: {},

  active_chart: activeChart.LINE_SIMPLE,

  event_data_chart: eventAdvertise.eventAdvertiseString.VIEW,

  price: 0,
};

const main = (state = mainState, action) => {
  let newState = state;

  switch (action.type) {
    case reportAction.SET_DATE_REPORT_FILTER:
      newState = {
        ...state,
        date_from: action.payload.date_from,
        date_to: action.payload.date_to,
      };
      break;

    case reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_SUCCESS:
      newState = {
        ...state,
        which_type_select: WhichTypeSelect.ALL_SITE_PUBLISHER,
        count_all_site_publisher: action.payload.report.count_site_publisher,

        count_all_positions:
          action.payload.report.count_all_positions_in_web_site_publisher,

        count_view_advertise_in_position_on_site_publisher:
          action.payload.report
            .count_all_view_advertises_in_all_positions_in_web_site_publisher,

        time_second_view_advertise_in_position_on_site_publisher:
          action.payload.report
            .time_second_view_advertises_in_all_positions_in_web_site_publisher,

        income: action.payload.report.income_in_all_positions_in_site_publisher,
      };
      break;

    case reportAction.GET_REPORT_WEB_SITE_PUBLISHER_SUCCESS:
      newState = {
        ...state,
        count_all_positions:
          action.payload.count_all_positions_in_web_site_publisher,

        count_view_advertise_in_position_on_site_publisher:
          action.payload
            .count_all_view_advertises_in_all_positions_in_web_site_publisher,

        time_second_view_advertise_in_position_on_site_publisher:
          action.payload
            .time_second_view_advertises_in_all_positions_in_web_site_publisher,

        income: action.payload.income_in_all_positions_in_site_publisher,
      };
      break;

    case reportAction.GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED:
      alert("گرفتن گزارش با مشکل روبرو شد");
      break;

    case reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_FAILED:
      alert("گرفتن گزارش با مشکل روبرو شد");
      break;

    case reportAction.GET_REPORT_WEB_SITE_PUBLISHER_FAILED:
      alert("گرفتن گزارش با مشکل روبرو شد");
      break;

    case reportAction.GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART_SUCCESS:
      newState = {
        ...state,
        data_chart: action.payload.dataChart,
        active_chart:
          helpersTime.getDifferentDates(
            action.payload.dateFrom.split("_")[0],
            action.payload.dateTo.split("_")[0]
          ) == 1
            ? activeChart.LINE_SIMPLE
            : activeChart.BAR,
      };
      break;

    case reportAction.SET_SITE_PUBLISHER_ID:
      newState = {
        ...state,
        site_publisher_ID: action.payload.site_publisher_ID,
        which_type_select: WhichTypeSelect.SPECIFIC_SITE_PUBLISHER,
      };
      break;

    case reportAction.EMPTY_SITE_PUBLISHER_DATA_SEPARATION:
      newState = {
        ...state,
        data_chart_separation: {},
      };
      break;

    case reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_SUCCESS:
    newState = {
        ...state,
        data_chart_separation: action.payload
      };
      break;

    case reportAction.SET_TYPE_SEPARATION_DATA_CHART:
      newState = {
        ...state,
        separation_data_chart: action.payload.separation,
      };
      break;

    case reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED:
      alert("گرفتن گزارش با مشکل روبرو شد");
      break;
  }

  return newState;
};
export default main;
